var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/no-floating-promises */
import { Box, Flex, Text } from 'pcln-design-system';
import React, { useContext, useState } from 'react';
import { DialogInputSection } from './DialogInputSection';
import { submitChatMessages } from './submitChatMessages';
import { ScrollIntoView } from './ScrollIntoView';
import { DialogLoading } from './DialogLoading';
import { TravelBotChatSingleDialogGeneric } from './TravelBotChatSingleDialogGeneric';
import { QuickActions } from './QuickActions';
import { ChatbotDataContext } from './context/ChatbotDataContext';
/**
 * ChatDialogMainContentSection
 * Main chat content
 * @public
 */
export var ChatDialogMainContentSection = function () {
    var _a = useContext(ChatbotDataContext), setCachedMessages = _a.setCachedMessages, setCachedPrompts = _a.setCachedPrompts, cachedMessages = _a.cachedMessages, cachedPrompts = _a.cachedPrompts, submitChatMessagesPayload = _a.submitChatMessagesPayload, handleMarkerResponse = _a.handleMarkerResponse, fetchRequestOptions = _a.fetchRequestOptions, markerComponents = _a.markerComponents;
    var _b = useState(''), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = useState(false), isLoading = _c[0], setLoadingStatus = _c[1];
    // ChatMessages keeps the data that would display to the user
    var _d = useState(__spreadArray([], cachedMessages, true)), chatMessages = _d[0], setChatMessage = _d[1];
    // Prompts keeps the data that would submit to the api
    var _e = useState(__spreadArray([], cachedPrompts, true)), prompts = _e[0], setPrompts = _e[1];
    var _f = useState(false), isDisablingInput = _f[0], setIsDisablingInputValue = _f[1];
    var _g = useState(''), fullStreamingTexts = _g[0], setStreamingText = _g[1];
    var markerComponentsKeys = Object.keys(markerComponents);
    var submitChatMessagesOptions = {
        setChatMessage: setChatMessage,
        setPrompts: setPrompts,
        setStreamingText: setStreamingText,
        setLoadingStatus: setLoadingStatus,
        setErrorMessage: setErrorMessage,
        // Cache control
        cacheControl: {
            setCachedMessages: setCachedMessages,
            setCachedPrompts: setCachedPrompts,
        },
        requestOptions: fetchRequestOptions,
        markerComponentsKeys: markerComponentsKeys,
        handleMarkerResponse: handleMarkerResponse,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { width: 1, height: 'calc(100% - 120px)', style: { position: 'fixed', top: '50px', overflowY: 'scroll', overflowX: 'hidden' } },
            React.createElement(Flex, { p: 3, width: 1, minHeight: '100%', flexDirection: 'column', justifyContent: 'flex-end' },
                chatMessages.map(function (m, i) {
                    if (markerComponents[m.content] && typeof markerComponents[m.content] === 'function') {
                        var Marker = markerComponents[m.content];
                        var markeComponentProps = (m === null || m === void 0 ? void 0 : m.markerComponentProps) || {};
                        var markerProps = __assign(__assign({}, markeComponentProps), { isLoading: isLoading, setIsDisablingInputValue: setIsDisablingInputValue, chatMessages: chatMessages, setChatMessage: setChatMessage, submitMessages: function (msg, updatedChatMessage) {
                                submitChatMessages(__assign({ submitChatMessagesPayload: __assign(__assign({}, submitChatMessagesPayload), { prompts: __spreadArray(__spreadArray([], prompts, true), [msg], false) }), 
                                    // Local state control
                                    chatMessages: !Array.isArray(updatedChatMessage) || updatedChatMessage.length === 0
                                        ? chatMessages
                                        : updatedChatMessage }, submitChatMessagesOptions));
                            } });
                        return (React.createElement(ScrollIntoView, { key: "chat-msg-".concat(i) },
                            React.createElement(Marker, __assign({}, markerProps))));
                    }
                    return (React.createElement(ScrollIntoView, { key: "chat-msg-".concat(i) },
                        React.createElement(TravelBotChatSingleDialogGeneric, { message: m })));
                }),
                errorMessage && (React.createElement(ScrollIntoView, null,
                    React.createElement(Box, { my: 3, p: 3 },
                        React.createElement(Text, { color: 'error.base' }, errorMessage),
                        React.createElement(Text, { color: 'error.base' }, "Please retry!")))),
                isLoading && (React.createElement(ScrollIntoView, null,
                    React.createElement(DialogLoading, { streamingText: fullStreamingTexts }))),
                React.createElement(QuickActions, { hasOtherMessage: chatMessages.length > 1, submitQuickActionMessage: function (action) {
                        var chatContent = action.chatContent, promptContent = action.promptContent;
                        var promptMessage = {
                            content: promptContent || chatContent,
                            role: 'user',
                        };
                        var chatMessage = {
                            content: chatContent,
                            role: 'user',
                        };
                        var updatedChatMessages = __spreadArray(__spreadArray([], chatMessages, true), [chatMessage], false);
                        // set user's message
                        setChatMessage(updatedChatMessages);
                        setCachedMessages(chatMessage);
                        setCachedPrompts(promptMessage);
                        // submit user's message to get response
                        submitChatMessages(__assign({ submitChatMessagesPayload: __assign(__assign({}, submitChatMessagesPayload), { prompts: __spreadArray(__spreadArray([], prompts, true), [promptMessage], false) }), 
                            // Local state control
                            chatMessages: updatedChatMessages }, submitChatMessagesOptions));
                    } }))),
        React.createElement(Box, { width: 1, style: { position: 'fixed', bottom: '0px' } },
            React.createElement(DialogInputSection
            // from local state
            , { 
                // from local state
                isDisablingInput: isDisablingInput, isLoading: isLoading, chatMessages: chatMessages, setChatMessage: setChatMessage, setErrorMessage: setErrorMessage, submitInputValue: function (msg, updatedChatMessage) {
                    submitChatMessages(__assign({ submitChatMessagesPayload: __assign(__assign({}, submitChatMessagesPayload), { prompts: __spreadArray(__spreadArray([], prompts, true), [msg], false) }), 
                        // Local state control
                        chatMessages: updatedChatMessage }, submitChatMessagesOptions));
                } }))));
};
//# sourceMappingURL=ChatDialogContent.js.map